export { default } from './CartPromoItem';
